// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__1M5BR","textInput":"styles_textInput__gzZi0"};